import { useContext } from "react";
import { CurrentUserContext } from "../context";

export const useCurrentUser = () => {
  const { user, loaded } = useContext(CurrentUserContext);
  return { user, loaded };
};
